/* SansMinds app shell behaviours — installed PWA only.
   Everything here no-ops unless html.pwa-app is set (see theme.liquid head
   script). Ships the interactions the Apple Store app is recognised by:
   a collapsing nav-bar title, a contextual back button, and per-tab scroll
   memory so switching tabs returns you where you left off. */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('pwa-app')) return;

  var bar = document.querySelector('[data-pwa-appbar]');
  var tabbar = document.querySelector('[data-pwa-tabbar]');

  function tabRoots() {
    if (!tabbar) return [];
    return Array.prototype.slice.call(tabbar.querySelectorAll('a[href]')).map(function (a) {
      return a.getAttribute('href');
    });
  }

  function normalise(path) {
    if (!path) return '/';
    return path.replace(/\/+$/, '') || '/';
  }

  var here = normalise(location.pathname);
  /* The manifest's start_url is "/", so the storefront home is where a launch
     from the icon lands — treat it as a tab root even though no tab points at
     it, otherwise the app opens showing a back button to nowhere. */
  var isTabRoot = here === '/' || tabRoots().some(function (href) {
    try { return normalise(new URL(href, location.origin).pathname) === here; }
    catch (e) { return false; }
  });

  /* --- Back button ------------------------------------------------------- */
  /* iOS shows a back chevron on pushed screens, never on a tab root. */
  var back = bar && bar.querySelector('[data-pwa-back]');
  if (back) {
    if (!isTabRoot && window.history.length > 1) {
      back.hidden = false;
      /* Member screens (warranties, achievements, wait list) print their own
         "Back to profile" link, which in the app sits directly under the bar's
         chevron and reads as the same control twice (owner, 2026-09-14). The
         class is what hides it - stamped HERE rather than on html.pwa-app
         generally, because the bar's chevron is not always there: on a cold
         open there is no history to step back through, the chevron stays
         hidden, and the in-page link is then the only way back. */
      root.classList.add('pwa-has-back');
      back.addEventListener('click', function () { window.history.back(); });
    } else {
      back.hidden = true;
    }
  }

  /* --- Sheet close --------------------------------------------------------
     The account screen is presented as a sheet, so its control dismisses rather
     than navigates: step back to whatever opened it. The href (the app home) is
     the fallback for a cold open — landing on the screen directly from the home
     icon or a shared link, where there is nothing to go back to. */
  (function () {
    var closer = document.querySelector('[data-pwa-sheet-close]');
    var sheet = document.querySelector('body.template-page-dashboard .frame');

    function dismiss(fallbackHref) {
      if (window.history.length > 1) { window.history.back(); return; }
      window.location.href = fallbackHref || '/';
    }

    if (closer) {
      closer.addEventListener('click', function (e) {
        if (window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    }

    /* --- Drag to dismiss ---------------------------------------------------
       A sheet is also dismissed by pulling it down, which is how most people
       actually close one. The gesture may only start at the very top of the
       scroll: anywhere else a downward drag is a scroll, and stealing it would
       make the screen feel broken. */
    if (!sheet) return;

    if (!('ontouchstart' in window)) return;

    var DISMISS_PX = 120;      // far enough to be deliberate
    var DISMISS_VELOCITY = 0.5; // px/ms - a quick flick counts even if short
    var startY = 0, startX = 0, lastY = 0, lastT = 0, prevY = 0, prevT = 0, delta = 0;
    var dragging = false, decided = false;

    sheet.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      if (window.scrollY > 0) return;
      startY = lastY = prevY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
      lastT = prevT = Date.now();
      delta = 0;
      dragging = true;
      decided = false;
    }, { passive: true });

    sheet.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var y = e.touches[0].clientY;
      var dy = y - startY;
      var dx = e.touches[0].clientX - startX;

      /* First meaningful movement decides whose gesture this is. Upward, or
         mostly sideways (a carousel), and we let go of it for good. */
      if (!decided) {
        if (Math.abs(dy) < 6 && Math.abs(dx) < 6) return;
        decided = true;
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) { dragging = false; return; }
        document.body.classList.add('is-sheet-dragging');
      }

      if (dy < 0) dy = 0;
      /* Resistance, so the sheet feels attached rather than free. */
      delta = dy < DISMISS_PX ? dy : DISMISS_PX + (dy - DISMISS_PX) * 0.35;
      sheet.style.transform = 'translateY(' + delta + 'px)';
      prevY = lastY; prevT = lastT;
      lastY = y;
      lastT = Date.now();
      e.preventDefault();
    }, { passive: false });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      document.body.classList.remove('is-sheet-dragging');
      if (!decided) return;

      /* Velocity of the LAST movement, not the whole drag: dividing the total
         distance by the time since the final move made every drag look like a
         flick (that gap is ~0ms), so any small pull dismissed the sheet. A
         finger that came to rest before lifting has no throw at all. */
      var velocity = (Date.now() - lastT > 100)
        ? 0
        : (lastY - prevY) / Math.max(1, lastT - prevT);

      if (delta > DISMISS_PX || velocity > DISMISS_VELOCITY) {
        sheet.style.transform = '';
        document.body.classList.add('is-sheet-leaving');
        var href = closer ? closer.getAttribute('href') : '/';
        setTimeout(function () { dismiss(href); }, 260);
      } else {
        sheet.style.transform = '';
      }
    }

    sheet.addEventListener('touchend', endDrag, { passive: true });
    sheet.addEventListener('touchcancel', endDrag, { passive: true });
  })();

  /* --- Bar fill ------------------------------------------------------------
     Separate from the title. The fill exists so the back button stays readable
     once anything scrolls under it; the title appears later, when the page's
     own heading passes beneath. Tying both to the heading meant that on a
     product page - where the heading is an editorial line further down - "Back"
     sat unreadable on top of live content. */
  (function () {
    var bar = document.querySelector('[data-pwa-appbar]') || document.querySelector('.pwa-appbar');
    if (!bar) return;
    var solid = function () { bar.classList.toggle('is-solid', window.scrollY > 12); };
    solid();
    window.addEventListener('scroll', solid, { passive: true });
  })();

  /* --- Collapsing title -------------------------------------------------- */
  /* The compact title stays hidden until the page's own <h1> passes under the
     bar — Apple's large-title collapse, without restyling anyone's hero. */
  var titleEl = bar && bar.querySelector('[data-pwa-appbar-title]');
  if (titleEl) {
    /* The account header greets the member by name in an <h1>. On the profile
       that IS the page title, but on a tab screen it sits above the screen's
       real heading and comes first in the DOM - which is why the bar read
       "Rich" on Exclusive. Prefer any other h1, and fall back to the greeting
       only when it is the only one. */
    /* A template can name its own bar title; that beats guessing at headings.
       Falls back to the first non-greeting h1, then any h1. */
    var h1 = document.querySelector('main [data-pwa-title]')
          || document.querySelector('main h1:not(.app-acct__name)')
          || document.querySelector('main h1');
    var label = (h1 && h1.textContent.trim()) || '';
    if (!label) {
      var activeTab = tabbar && tabbar.querySelector('.pwa-tab.is-active .pwa-tab__label');
      label = activeTab ? activeTab.textContent.trim() : (document.title.split('–')[0] || '').trim();
    }
    titleEl.textContent = label;

    if (h1 && 'IntersectionObserver' in window) {
      var barH = bar.offsetHeight || 44;
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-titled', !entries[0].isIntersecting);
      }, { rootMargin: '-' + barH + 'px 0px 0px 0px', threshold: 0 }).observe(h1);
    } else {
      /* No h1 to track (the storefront home has none at all), or no
         IntersectionObserver. Showing the title immediately left the bar
         opaque with the browser title sitting in it at rest, which is exactly
         what the reference does not do — so fall back to revealing it once the
         page has actually been scrolled. */
      var onScroll = function () {
        bar.classList.toggle('is-titled', window.scrollY > 24);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* --- Per-tab scroll memory --------------------------------------------- */
  /* Apple keeps each tab parked where you left it. The browser only restores
     on back/forward, so we remember tab roots ourselves for the session. */
  var KEY = 'pwa:scroll:';
  function save() {
    if (!isTabRoot) return;
    try { sessionStorage.setItem(KEY + here, String(window.scrollY)); } catch (e) {}
  }
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });

  if (isTabRoot) {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var isReload = nav && nav.type === 'reload';
    if (!isReload) {
      try {
        var y = sessionStorage.getItem(KEY + here);
        if (y !== null && Number(y) > 0) {
          // After layout, so late-loading sections don't fight the restore.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { window.scrollTo(0, Number(y)); });
          });
        }
      } catch (e) {}
    }
  }

  /* --- The fan ------------------------------------------------------------ */
  /* One trigger holding search, bag, account and appearance. Opening arcs them
     out, dims the page and folds the tab pill away so the arc has room. */
  var fan = document.querySelector('[data-pwa-fan]');
  var dock = document.querySelector('[data-pwa-tabdock]');
  var scrim = null;

  function fanIsOpen() { return !!fan && fan.classList.contains('is-open'); }

  /* The other direction, watched rather than wired: the drawer opens from the
     bag button, from the fan, and automatically after an add-to-cart. Observing
     the class catches every one of those without touching storefront.js. */
  (function () {
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!drawer.classList.contains('is-open')) return;
      closeSearchIfOpen();
      if (fanIsOpen()) setFan(false);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  /* And the reverse: opening search puts away the cart and the fan, so the three
     never stack. Watched rather than wired, for the same reason as the drawer —
     search opens from the app bar, the fan and the tab dock. */
  (function () {
    var modal = document.querySelector('.search-modal, [data-search-modal]');
    if (!modal || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!modal.classList.contains('is-open')) return;
      closeCartIfOpen();
      if (fanIsOpen()) setFan(false);
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  })();

  /* The cart sheet, the fan and the sticky buy bar all live at the same bottom
     edge, so only one of them may be up at a time. Closed by clicking the
     drawer's own close control rather than stripping its class, so its scroll
     lock and focus handling unwind the way they normally do. */
  /* The cart sheet, the fan and the sticky buy bar share the bottom edge, so
     only one may be up at a time. No transition of our own: the sheet already
     has its slide, and layering a second animation on top of it - the genie
     experiment - stuttered badly on device because the dock's backdrop filter
     has to recompute every frame while anything moves beneath it. */
  var HANDOFF_MS = 180;

  /* Search is the third member of this group. It is a full-screen overlay at the
     same z-index as the cart drawer and it comes LATER in the document, so at
     equal z-index it always paints on top: opening the cart from the fan while
     search was up put the drawer behind it and read as "nothing happened".
     Closed via its own control so the scroll lock and focus unwind normally. */
  function closeSearchIfOpen() {
    var m = document.querySelector('.search-modal.is-open, [data-search-modal].is-open');
    if (!m) return false;
    var btn = m.querySelector('[data-search-close], .search-modal__close');
    if (btn) btn.click(); else m.classList.remove('is-open');
    return true;
  }

  function closeCartIfOpen(after) {
    var d = document.querySelector('.cart-drawer.is-open');
    if (!d) return false;
    var btn = d.querySelector('[data-cart-close], .cart-drawer__close');
    if (btn) btn.click(); else d.classList.remove('is-open');
    // Let the sheet finish leaving before the fan arcs up through that space.
    if (after) setTimeout(after, HANDOFF_MS);
    return true;
  }

  function setFan(open) {
    if (!fan) return;

    /* Hand off rather than overlap: let the sheet finish leaving before the fan
       arcs up through the space it just vacated. Opening both at once reads as
       a collision - the fan circles land on the Checkout button. */
    if (open) closeSearchIfOpen();
    if (open && closeCartIfOpen(function () { setFan(true); })) return;

    fan.classList.toggle('is-open', open);
    if (dock) dock.classList.toggle('is-fanned', open);
    /* The fan arcs up through exactly where the sticky buy bar sits, so the two
       cannot both be on screen. The fan is a deliberate tap, the buy bar is
       ambient - the deliberate one wins, and the bar comes straight back when
       the fan closes. Flagged on <html> because the bar lives in the page while
       the dock is a body-level element; no selector reaches between them. */
    document.documentElement.classList.toggle('pwa-fan-open', open);

    var trigger = fan.querySelector('[data-pwa-fan-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open && !scrim) {
      scrim = document.createElement('div');
      scrim.className = 'pwa-fan__scrim';
      document.body.appendChild(scrim);
      // Force a frame so the opacity transition actually runs.
      requestAnimationFrame(function () { scrim.classList.add('is-open'); });
      scrim.addEventListener('click', function () { setFan(false); });
    } else if (!open && scrim) {
      var dying = scrim;
      scrim = null;
      dying.classList.remove('is-open');
      setTimeout(function () {
        if (dying.parentNode) dying.parentNode.removeChild(dying);
      }, 240);
    }
  }

  if (fan) {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      if (e.target.closest('[data-pwa-fan-toggle]')) {
        e.preventDefault();
        setFan(!fanIsOpen());
        return;
      }
      /* Picking an action folds the fan away. The appearance switch is
         deliberately excluded so modes can be cycled and compared in place. */
      if (fanIsOpen() && e.target.closest('[data-pwa-fan-close]')) {
        setFan(false);
        return;
      }
      /* Anything outside the fan closes it — the scrim covers most of this,
         but the tab pill and the bar sit above the scrim. */
      if (fanIsOpen() && !e.target.closest('[data-pwa-fan]')) setFan(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fanIsOpen()) setFan(false);
    });
  }

  /* --- Dark mode switch ---------------------------------------------------
     A plain on/off control, not a three-way cycle — "System / Light / Dark"
     made people ask what it meant. The system state is still preserved, just
     invisibly: with no stored preference the app follows the phone, and if you
     flip the switch to whatever the phone is already doing the override is
     cleared rather than pinned. So "follow my phone" survives without being a
     third position anyone has to understand. */
  var THEME_KEY = 'sm:theme';

  function systemPrefersDark() {
    return !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
  }
  function storedMode() {
    var attr = root.getAttribute('data-theme');
    return (attr === 'light' || attr === 'dark') ? attr : null;
  }
  function isDarkNow() {
    var m = storedMode();
    return m ? m === 'dark' : systemPrefersDark();
  }

  /* The two media-scoped theme-color metas follow the OS, so an explicit
     choice needs a media-less one ahead of them or the status bar keeps the
     system's colour while the app shows the opposite. */
  function syncThemeColor(mode) {
    var head = document.head;
    var forced = head.querySelector('meta[name="theme-color"][data-pwa-forced]');
    if (!mode) {
      if (forced && forced.parentNode) forced.parentNode.removeChild(forced);
      return;
    }
    if (!forced) {
      forced = document.createElement('meta');
      forced.setAttribute('name', 'theme-color');
      forced.setAttribute('data-pwa-forced', '');
      head.insertBefore(forced, head.querySelector('meta[name="theme-color"]'));
    }
    forced.setAttribute('content', mode === 'dark' ? '#000000' : '#ffffff');
  }

  function paintSwitches() {
    var on = isDarkNow();
    var mode = storedMode();
    Array.prototype.forEach.call(document.querySelectorAll('[data-pwa-dark]'), function (sw) {
      sw.classList.toggle('is-on', on);
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      var noteEl = sw.closest('.notif-row');
      noteEl = noteEl && noteEl.querySelector('[data-pwa-dark-note]');
      if (noteEl) {
        noteEl.textContent = sw.getAttribute(
          !mode ? 'data-note-following' : (mode === 'dark' ? 'data-note-on' : 'data-note-off')
        ) || '';
      }
    });
  }

  function setDark(wantDark) {
    /* Asking for exactly what the phone already does means "follow the phone",
       so drop the override instead of freezing the current value. */
    var mode = (wantDark === systemPrefersDark()) ? null : (wantDark ? 'dark' : 'light');
    if (mode) root.setAttribute('data-theme', mode);
    else root.removeAttribute('data-theme');
    try {
      if (mode) localStorage.setItem(THEME_KEY, mode);
      else localStorage.removeItem(THEME_KEY);
    } catch (e) {}
    syncThemeColor(mode);
    paintSwitches();
  }

  /* Re-apply the stored preference to THIS document.
     data-theme is stamped by the head script, which runs once per real load.
     A back/forward step restores the previous page from the bfcache exactly as
     it was painted - so flipping the switch in Settings and pressing Back came
     back to a page still carrying the OLD data-theme, and the app appeared to
     jump between modes (owner, 2026-09-14). pageshow is the one event that
     fires on a bfcache restore, so the preference is read again there.
     Run unconditionally rather than only on event.persisted: a plain load just
     re-applies what the head script already did, and some engines restore
     without setting the flag. */
  function applyStoredTheme() {
    var pref = null;
    try { pref = localStorage.getItem(THEME_KEY); } catch (e) {}
    if (pref !== 'light' && pref !== 'dark') pref = null;
    if (pref) root.setAttribute('data-theme', pref);
    else root.removeAttribute('data-theme');
    syncThemeColor(pref);
    paintSwitches();
  }

  window.addEventListener('pageshow', applyStoredTheme);

  paintSwitches();
  syncThemeColor(storedMode());

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-pwa-dark]');
    if (!sw) return;
    e.preventDefault();
    setDark(!isDarkNow());
  });

  /* While no override is stored the app tracks the phone live. */
  if (window.matchMedia) {
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    var onSystemChange = function () { if (!storedMode()) paintSwitches(); };
    if (mq.addEventListener) mq.addEventListener('change', onSystemChange);
    else if (mq.addListener) mq.addListener(onSystemChange);
  }

  /* --- Keep the shell's cart badges in sync ------------------------------ */
  /* storefront.js already updates every [data-cart-count-bubble]; the tab-bar
     and nav-bar badges carry that attribute, so they come along for free. */
})();
